import React, { memo, useState } from "react";

import { formatNumber, useGetFarms, useTranslation } from "utils";

import { FieldListField, FieldShape } from "models";

import { ErrorBoundary, ExtraInfo, Flex, Link, MapStatic, Tag } from "components";

export type FieldHeadlineProps = {
  headline: string;
  field: FieldListField | null;
  shape: FieldShape | undefined;
  isLoading: boolean;
  isEnrolled: boolean | undefined;
};

export const FieldHeadline = memo(({ headline, field, shape, isLoading, isEnrolled }: FieldHeadlineProps) => {
  const { t } = useTranslation(["allFieldView"]);
  const { currentFarm } = useGetFarms();
  const carbonProgram = currentFarm?.carbonProgram;
  const [openProgramInfoDrawer, setOpenProgramInfoDrawer] = useState<boolean>(false);

  return (
    <div data-testid="field-headline-card">
      <h1 className="margin-bottom-150">{headline}</h1>
      <Flex justify="space-between" align="center" gap="1rem">
        <div className="field-headline-map-container" style={{ height: "5rem", width: "5rem" }}>
          {!isLoading && (
            <ErrorBoundary>
              {/* @ts-expect-error need to convert to tsx */}
              <MapStatic field={field} geometry={shape} location={field?.location} />
            </ErrorBoundary>
          )}
        </div>
        <Flex flex="2" vertical={true}>
          <h5 className="margin-0">{field?.name}</h5>
          <p data-testid="field-headline-card-field-size" className="paragraph-s grey-600-text margin-0">
            {formatNumber({ number: field?.size ?? 0 })}
            {t("fieldHeadlineCard.ha")}
          </p>
        </Flex>
        <Flex align="flex-end">
          {!isLoading && isEnrolled && (
            <Flex vertical={true} justify="space-around" align="flex-end">
              <Tag
                dataTestId="field-headline-card-field-enrollment-state"
                className="margin-right-0"
                colour="green-200"
                text={t("fieldHeadlineCard.enrolled")}
              />
              <Link
                dataTestId="field-headline-card-field-carbon-program-learn-more"
                size="small"
                type="primary-link"
                onClick={() => setOpenProgramInfoDrawer((prevState) => !prevState)}
              >
                {t("fieldHeadlineCard.learnMore")}
              </Link>
            </Flex>
          )}
        </Flex>
      </Flex>
      {carbonProgram && <ExtraInfo visible={openProgramInfoDrawer} type={carbonProgram.programSlug} setVisible={setOpenProgramInfoDrawer} />}
    </div>
  );
});
